<template>
  <base-card style="height: 180px" @click="handleRecipeClick">
    <base-card-title>
      {{ props.name }}
    </base-card-title>

    <base-card-text>
      <base-row style="height: 50px"
        ><base-col cols="12"
          >{{ shortDescription }}
          <v-tooltip
            v-if="isDescriptionLengthy"
            activator="parent"
            location="bottom"
            max-width="300px"
          >
            {{ props.description }}
          </v-tooltip>
        </base-col></base-row
      >
      <base-row class="mt-2">
        <base-col cols="12">
          <base-icon>mdi-account</base-icon>
          <span v-if="isFetchingData">
            <base-progress-circular
              indeterminate
              color="primary"
              class="profile__selection__loading"
              :width="3"
              :size="20"
            />
          </span>
          <span v-else>{{ audienceCount }}</span></base-col
        >
      </base-row>
    </base-card-text>

    <base-card-actions>
      <base-row class="pl-5">
        <base-col class="pa-0 mr-3" cols="auto">
          <span v-if="isFetchingData">
            <base-progress-circular
              indeterminate
              color="primary"
              class="profile__selection__loading"
              :width="3"
              :size="20"
            />
          </span>
          <span v-else>{{ createdCount }}</span>
          {{ t('messages.created') }}</base-col
        >
        <base-col v-if="false" class="pa-0" cols="auto">
          <span v-if="isFetchingData">
            <base-progress-circular
              indeterminate
              color="primary"
              class="profile__selection__loading"
              :width="3"
              :size="20"
            />
          </span>
          <span v-else>{{ activeCount }}</span>
          {{ t('messages.active') }}</base-col
        >
      </base-row>
    </base-card-actions>
  </base-card>
</template>

<script lang="ts" setup>
  import {
    BaseCard,
    BaseCardActions,
    BaseCardText,
    BaseCardTitle,
    BaseIcon,
    BaseRow,
    BaseCol,
    BaseProgressCircular
  } from '@deltax/vuetify-wrapper-components'

  import SegmentTemplateService from '@/services/segmentTemplateService'
  import { useAppStore } from '@/store/app'
  import { computed, onMounted, ref } from 'vue'
  import { useI18n } from 'vue-i18n'
  import { useRouter } from 'vue-router'
  import { VTooltip } from 'vuetify/lib/components/index.mjs'
  import useAudienceStore from '@/store/audience'

  const { t } = useI18n()

  interface Props {
    id: number
    name: string
    description: string
  }
  const props = defineProps<Props>()
  const appStore = useAppStore()
  const audienceStore = useAudienceStore()
  const router = useRouter()
  const segmentTemplateService = new SegmentTemplateService()

  const audienceCount = ref(0)
  const createdCount = ref(0)
  const activeCount = ref(0)
  const isFetchingData = ref(false)
  const isDescriptionLengthy = ref(false)

  const shortDescription = computed(() => {
    if (props.description?.length < 60) {
      return props.description
    }
    return props.description?.substring(0, 60) + '...'
  })

  onMounted(async () => {
    if (props.description?.length >= 60) {
      isDescriptionLengthy.value = true
    }
    let recipeDetails = audienceStore.getRecipeDetail(props.id)

    if (recipeDetails) {
      audienceCount.value = recipeDetails?.audienceCount
      createdCount.value = recipeDetails?.createdCount
      activeCount.value = recipeDetails?.activeCount
    } else if (appStore.getSelectedBusinessProfile) {
      isFetchingData.value = true
      let insightResponse =
        await segmentTemplateService.GetSegmentTemplateInsights(
          appStore.getSelectedBusinessProfile.id,
          props.id
        )
      audienceCount.value = insightResponse.estimatedAudienceSize
      createdCount.value = insightResponse.createdSegments
      activeCount.value = insightResponse.activeSegments
      isFetchingData.value = false
      audienceStore.setRecipeDetail(props.id, {
        activeCount: activeCount.value,
        audienceCount: audienceCount.value,
        createdCount: createdCount.value
      })
    }
  })

  const handleRecipeClick = () => {
    router.push({
      name: 'audienceCreation',
      query: { segmentTemplateId: props.id }
    })
  }
</script>
